/**
 * client/wrapper type for the DOM widget on parent/page
 */
import BaseWidgetClient from '../core/BaseWidgetClient';
import DOMPositioner from '../core/positioners/DOMPositioner';
import WidgetTypes from '../core/enums/WidgetTypes';
import parseTemplate from '../core/hooks/parseTemplate';
import Browser from '../core/hooks/Browser';
import WidgetStates from '../core/hooks/WidgetStates';
import createNS from '../core/createNs';
import isTabletOrIpad from '../isTabletOrIpad';

export default function RegisterDOM() {
    const DOM = class extends BaseWidgetClient {
        constructor(options) {
            super(
                Object.assign(options, {
                    widget: WidgetTypes.DOM,
                    elDragnDrop: 'apexchat_dom_dragndrop'
                })
            );
            this.ready();
            const iframe = document.getElementById(this.iframeId);
            let frameDoc = iframe?.document;
            if (iframe?.contentWindow) {
                frameDoc = iframe.contentWindow.document;
            }
            this.positioner = new DOMPositioner(this.options, frameDoc || null);
        }

        ready() {
            super.ready();
            const me = this;
            me.subscribe(WidgetTypes.DOM + WidgetStates.ShownMaximized, () => {
                if (!me.isMobile()) {
                    // me.handleZooming();
                }
            });
            me.subscribe(WidgetTypes.DOM + WidgetStates.Hidden, () => {
                document.getElementById(me.parentDivId).style.display = 'none';
            });
            me.subscribe(WidgetTypes.DOM + WidgetStates.ShownMaximized, (args) => {
                document.getElementById(me.parentDivId).style.display = 'block';
            });
            window.addEventListener('resize', handleWindowEvents);
            window.addEventListener('scroll', handleWindowEvents);
            window.addEventListener('orientationchange', handleWindowEvents);
            function handleWindowEvents(e) {
                const isScroll = e.type == 'scroll';
                // We do not need resize function on drag n drop - CHAT-8138
                if (e.type != 'resize') {
                    const data = { options: me.options };
                    me.positioner.position({
                        element: me.parentDivId,
                        widgetType: WidgetTypes.DOM,
                        model: data,
                        isScroll
                    });
                }
            }
            this.create();
        }

        create() {
            super.create();
            const me = this;
            let dragDropCSS = 'standard_dialog';
            me.$container.style.zIndex = '9999999999';
            me.$container.style.display = 'none';

            me.options.chatWidth = '392px';
            // me.options.chatWidth = ApexChat.IsRoundedDynamicPlusTheme ? '450px' : '392px';
            if (
                /iPad|iPhone|iPod/.test(navigator.userAgent) ||
                /Android/i.test(navigator.userAgent)
            ) {
                me.options.chatWidth = '100%';
            }
            // check skinnable and image based widget enabled then run below condition
            if (
                (me.options && me.options.skinnable) ||
                (me.options.skinRegions && me.options.skinRegions.length > 0)
            ) {
                dragDropCSS = 'standard_dialog';
            } else {
                dragDropCSS = 'livechat_dialog';
            }

            let themeClass = ApexChat.IsRoundedDynamicPlusTheme ? "livechat-rd-plus-theme-iframe" : "livechat-rd-theme-iframe";
            me.$container.classList.add(themeClass)
            // TODO: These 3 lines are similer we need some generic work here to cater it.
            me.$container.innerHTML = `<iframe  tabindex="0"  class="${me.widget}_frame ${me.widget}_iframe_custom apexchat_zooming_iframe_standard ${themeClass}"  id="${me.iframeId}" width="${me.options.chatWidth}" style="border: none;overflow-x:hidden; overflow-y:hidden;display: block;width:${me.options.chatWidth};"  marginheight="0" marginwidth="0" frameBorder="0" scrolling="no" horizontalscrolling="no" verticalscrolling="no"  allowtransparency="true" title="Chat Window"></iframe><div id="${me.elDragnDrop}" class="${dragDropCSS}"><div id="apexchat_DOM_loading"></div></div>`; // background-color: #534444;

            me.options.chatWidth = ApexChat.IsRoundedDynamicPlusTheme ? '492px' : '422px';
            if (me.isMobile() && !isTabletOrIpad()) {
                me.options.chatWidth = '100%';
            }
            let drageAndDropTopPosition = 50;
            if (Browser.isFirefox()) {
                drageAndDropTopPosition = 112;
            }
            // CHAT-6673- get company chat title so we can show it on hover of header text.
            const { chatTitleTemplate } = me.options.profileTextsHash[me.options.language];
            const companyChatTitle = parseTemplate(
                chatTitleTemplate,
                ApexChat.options
            );
            const iFrameStyle = `border: none; overflow-x:hidden; overflow-y:hidden; display: block;width:${me.options.chatWidth};`;
            var draggerClass = 'apexchat_dom_dragger';
            if (me.options.videoGreet && me.options.videoGreet.persistVideoRatioForWidget) {
                draggerClass = 'apexchat_dom_dragger_video_greet_fluid';
            }
            me.$container.innerHTML =
                '<iframe  class="' +
                me.widget +
                '_frame ' +
                me.widget +
                '_iframe_custom iframe_zooming_dom_desktop"  id="' +
                me.iframeId +
                '" width="' +
                me.options.chatWidth +
                '" style="' +
                iFrameStyle +
                '" marginheight="0" marginwidth="0" frameBorder="0" scrolling="no" horizontalscrolling="no" verticalscrolling="no"  allowtransparency="true" title="Chat Window"></iframe><div id="' +
                me.elDragnDrop +
                '" class="' +
                draggerClass +
                '" title="' +
                companyChatTitle +
                '" ><div id="apexchat_DOM_loading"></div></div>'; //background-color: #534444;

            // uncomment for iOS testing through ngrok
            // me.options.isMobile = true

            if ((me.options.isMobile || /Android/i.test(navigator.userAgent))
            ) {
                // width and height of iframe for rd theme in mobile should be 100%
                me.$container.innerHTML = `<iframe  class="${me.widget}_frame ${me.widget}_iframe_custom"  id="${me.iframeId}"style="right:0;left:0;top:0;bottom:0;position:fixed;border: none;overflow-x:hidden; overflow-y:hidden;display: block;width:${me.options.chatWidth};height:100%; marginheight="0" marginwidth="0" frameBorder="0" scrolling="no" horizontalscrolling="no" verticalscrolling="no"  allowtransparency="true" title="Chat Window"></iframe><div id="${me.elDragnDrop}" style="width: 15px; height: 15px;  position: absolute; right: 75px; top: 25px;cursor:move;"><div id="apexchat_DOM_loading"></div></div>`; // background-color: #534444;
            }
            document.body.appendChild(me.$container);
            me.show();
        }

        show() {
            super.show();
        }

        handleZooming() {
            const me = this;
            me.$(window).resize(() => {
                const iframe = document.getElementById(me.iframeId);
                const parentDiv = document.getElementById(me.parentDivId);
                let frameDoc = iframe.document;
                if (iframe.contentWindow) {
                    frameDoc = iframe.contentWindow.document;
                }
                if (window.devicePixelRatio >= 1.12 && window.devicePixelRatio < 1.5) {
                    parentDiv.style.transform = 'scale(1)';
                    const innerDomDiv = frameDoc.getElementById('apexchat_dompopup_chatwindow_max');
                    innerDomDiv.style.bottom = '10px'
                    // var body = frameDoc.body;
                } else if (window.devicePixelRatio >= 1.5 && window.devicePixelRatio < 1.75) {
                    parentDiv.style.transform = 'scale(0.8)';
                    parentDiv.style.bottom = '-55px';
                } else if (window.devicePixelRatio >= 1.75 && window.devicePixelRatio < 2.0) {
                    parentDiv.style.transform = 'scale(0.78)';
                    parentDiv.style.bottom = '-68px';
                } else if (window.devicePixelRatio >= 2.0 && window.devicePixelRatio < 2.5) {
                    parentDiv.style.transform = 'scale(0.68)';
                    parentDiv.style.bottom = '-94px';
                } else if (window.devicePixelRatio >= 2.5 && window.devicePixelRatio <= 3.0) {
                    parentDiv.style.transform = 'scale(0.55)';
                    parentDiv.style.bottom = '-132px';
                } else {
                    parentDiv.style.transform = 'scale(1)';
                }
            });
        }
    };
    const fqName = `${WidgetTypes.DOM}_client`;
    // Export to window
    createNS(fqName, DOM);
}
